import { environment } from './../environments/environment';
import { NgModule } from '@angular/core';
import { NgbActiveModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { OAuthModule } from 'angular-oauth2-oidc';

import { AlmaOidcModule } from '@almaobservatory/alma-oidc-client';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { PageHeaderComponent } from './page-header/page-header.component';

import { HttpErrorInterceptor } from './http-error.interceptor';
import { MessageExchange } from './message-exchange';
import { ErrorBoxComponent } from './error-box/error-box.component';
import { TabExpertiseComponent } from './tab-expertise/tab-expertise.component';

@NgModule({ declarations: [
        AppComponent,
        PageHeaderComponent,
        ErrorBoxComponent,
        TabExpertiseComponent
    ],
    bootstrap: [AppComponent], imports: [NgbModule,
        BrowserModule,
        AppRoutingModule,
        FormsModule,
        ReactiveFormsModule,
        OAuthModule.forRoot(),
        AlmaOidcModule.forRoot({ securedURLs: environment.securedUrls }),
        CommonModule], providers: [NgbActiveModal,
        MessageExchange,
        { provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, deps: [MessageExchange], multi: true }, provideHttpClient(withInterceptorsFromDi())] })
export class AppModule { }
